import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'how_are_hours_of_work_recorded_for_wrkrs_select_all_that_apply'

export const dataPointDefinition = {
  retracedId: 'how_are_hours_of_work_recorded_for_wrkrs_select_all_that_apply',
  name: 'How are hours of work recorded for workers?',
  description:
    'The intent of this question is to understand how working hours are recorded for workers. It is asking about what type of "time clock" system is in place for recording working hours. Recording working hours is also known as "clocking-in" or "clocking-out".\r\r\n\r\r\nFor example, if workers use a traditional punch card system to clock-in and out, the selection would be "Mechanically".',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'MANUALLY_I_E_WRITTEN_RECORD_',
      text: 'Manually (i.e. written record)',
      externalIds: [
        {
          id: 'wh-1-1x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'MECHANICALLY_I_E_PUNCH_CARD_',
      text: 'Mechanically (i.e. punch card)',
      externalIds: [
        {
          id: 'wh-1-2x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'ELECTRONICALLY_I_E_SWIPE_CARD_',
      text: 'Electronically (i.e. swipe card)',
      externalIds: [
        {
          id: 'wh-1-3x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'BIOMETRICALLY_I_E_FINGERPRINT_FACE_SCAN_',
      text: 'Biometrically (i.e. fingerprint/face scan)',
      externalIds: [
        {
          id: 'wh-1-4x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NONE_OF_THE_ABOVE',
      text: 'None of the above',
      externalIds: [
        {
          id: 'wh-1-5x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'If none of the above, please describe how the facility records hours of work:',
        externalIds: [
          {
            id: 'wh-wor-3f',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'MANUALLY_I_E_WRITTEN_RECORD_',
                'MECHANICALLY_I_E_PUNCH_CARD_',
                'ELECTRONICALLY_I_E_SWIPE_CARD_',
                'BIOMETRICALLY_I_E_FINGERPRINT_FACE_SCAN_',
                'NONE_OF_THE_ABOVE',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wh-wor-2',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 6340,
  sectionId: '2.2.12',
  impactArea: 'Working Hours',
  impactAreaId: 'WORKING_HOURS_AND_OVERTIME',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
